import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useApiClient } from "../../../api";
import { enqueueSnackbar } from "notistack";

export const OffboardSchoolDialog = ({ open, setOpen, school }) => {
  const ApiClient = useApiClient();

  const offboardSchool = async () => {
    try {
      const result = await ApiClient.schools.offboardSchool({
        school: school.id,
      });
      if (result.success) {
        enqueueSnackbar(result.message, {
          variant: "success",
          autoHideDuration: 3000,
        });
        setOpen(false);
      } else {
        enqueueSnackbar(result.message, {
          variant: "error",
          autoHideDuration: 3000,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth={"md"}
    >
      <DialogTitle>Offboard School</DialogTitle>
      <DialogContent>
        Are you sure you want to do this? It will pseudonymise all staff and
        students and remove all user access.
      </DialogContent>
      <DialogActions>
        <Button variant={"outlined"} onClick={offboardSchool}>
          Confirm
        </Button>
        <Button onClick={() => setOpen(false)} variant={"contained"}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
